// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"eef44ebd","212":"fc867fd4","468":"bf9bf184","964":"d2e19116"}[chunkId] + ".chunk.js";
};